<template>
  <Accordion
    :error="$v.payments.$error"
    id="payments"
    title="FORMA DE PAGAMENTO"
  >
    <b-row class="row-padding">
      <b-col md="6">
        <b-row>
          <b-col md="12">
            <SelectWithSearch
              labelBusca="name"
              label="Forma de Pagamento"
              placeholder="Pesquise a forma de pagamento"
              v-model="payments.payment"
              inputClass="search-product"
              :error="$v.payments.paymentModeCollection.$error"
              :options="paymentCollection"
              :disabled="hasNoneInPaymentModeCollection || this.editPayment"
              :change="changePaymentSelected"
            >
              <template slot="no-options">
                Nenhum pagamento encontrado
              </template>
              <template slot="options" slot-scope="props">
                <div class="selected" style="text-transform: uppercase">
                  {{ props.data.name }}
                </div>
              </template>
              <template slot="selected" slot-scope="props">
                <div class="selected" style="text-transform: uppercase">
                  {{ props.data.name }}
                </div>
              </template>
            </SelectWithSearch>
          </b-col>
        </b-row>
        <b-row class="table-installments mt-4" v-if="isValidPayment">
          <b-col md="12">
            <InstallmentTable :payment="payments" />
          </b-col>
        </b-row>
        <b-row class="row-padding mt-2" v-if="!editPayment">
          <Button
            align="center"
            class="text-center"
            type="success"
            :fullWidth="true"
            v-if="isValidPayment"
            @click="setPaymentModeCollection()"
          >
            Adicionar
          </Button>
        </b-row>
        <b-row class="row-padding mt-2" v-if="editPayment">
          <b-col md="6">
            <Button
              align="center"
              class="text-center"
              type="success"
              :fullWidth="true"
              @click="saveEditPaymentModeCollection()"
            >
              Alterar
            </Button>
          </b-col>
          <b-col md="6">
            <Button
              align="center"
              class="text-center"
              type="error"
              :fullWidth="true"
              @click="cancelEditPaymentModeCollection()"
            >
              Cancelar
            </Button>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="6">
        <b-row>
          <b-col md="12" lg="6">
            <InputMoney
              labelBold
              label="Valor R$:"
              id="value"
              v-model="payments.payment.value"
              :precision="2"
              :onKeyup="changePaymentValue"
            />
          </b-col>
          <b-col md="12" lg="6">
            <Label>Conta</Label>
            <SelectWithSearch
              labelBusca="name"
              v-model="payments.payment.account"
              placeholder="Selecione uma conta"
              inputClass="search-account"
              :disabled="!isValidPayment"
              :options="accountCollection"
              :clearable="false"
              :change="changeAccountSelected"
            >
              <template slot="no-options"> Nenhuma conta encontrada </template>
              <template slot="options" slot-scope="props">
                <div class="selected" style="text-transform: uppercase">
                  {{ props.data.name }}
                </div>
              </template>
              <template slot="selected" slot-scope="props">
                <div class="selected" style="text-transform: uppercase">
                  {{ props.data.name }}
                </div>
              </template>
            </SelectWithSearch>
          </b-col>
          <b-col md="12" class="mt-3">
            <Label>Informações Complementares:</Label>
            <b-textarea
              class="input"
              v-model="purchase.observation"
            ></b-textarea>
          </b-col>
          <b-col md="12" class="mt-3">
            <SelectCategory
              :disabled="!isValidPayment"
              :types="[categoryEnum.EXPENSE, categoryEnum.EXPENSE_AND_REVENUE]"
              v-model="payments.payment.category"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row align-h="end" class="row-padding">
      <b-col md="6" class="mt-2">
        <b-row align-h="end">
          <b-col md="12" lg="7" align="right">
            <strong>Total Restante:</strong>
            R$ {{ valorReal(payments.remainder) }}
          </b-col>
          <b-col md="12" lg="5" align="right">
            <strong>Total:</strong>
            R$ {{ valorReal(taxCalc.vNF) }}
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row
      class="form-group row-padding"
      v-if="payments.paymentModeCollection.length"
    >
      <b-col class="busca">
        <table class="table">
          <thead>
            <tr>
              <th>Pagamento</th>
              <th>Valor</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(payment, key) in payments.paymentModeCollection"
              :key="'payment' + key"
            >
              <td>{{ payment.name }}</td>
              <td>R$ {{ valorReal(payment.value) }}</td>
              <td align="right">
                <a
                  href="javascript:"
                  @click="editPaymentModeCollection(key)"
                  class="edit-payment"
                  v-if="!isNoneByString(payment.name)"
                >
                  <Edit title="Editar" />
                </a>
                <a
                  href="javascript:"
                  @click="removePaymentModeCollection(key)"
                  class="remove-payment"
                >
                  <Close title="Excluir" />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </Accordion>
</template>

<script>
import { Accordion, SelectCategory } from '@/components';
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import Close from 'vue-material-design-icons/Close';
import Edit from 'vue-material-design-icons/Pencil';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import InstallmentsMixin from '@/modules/Application/mixins/InstallmentsMixin';
import { SelectWithSearch, Button, InputMoney, Label } from '@/components/Form';
import { InstallmentTable } from '@/components/Table';
import { required } from 'vuelidate/lib/validators';
import { CategoryEnum } from '@/modules/Finance/enums/CategoryEnum';
import { NENHUM } from '../../../Payment/enums/PaymentModeTypeEnum';

export default {
  name: 'payment',
  components: {
    Accordion,
    SelectWithSearch,
    Close,
    Edit,
    Button,
    InputMoney,
    InstallmentTable,
    Label,
    SelectCategory,
  },
  mixins: [FormatMixin, InstallmentsMixin],
  validations: {
    payments: {
      paymentModeCollection: {
        required,
      },
    },
  },
  data() {
    return {
      indexEdit: null,
      editPayment: null,
      categoryEnum: CategoryEnum,
    };
  },
  async mounted() {
    this.payments.payment = [];
    await this.setInitialCollections();
    this.setDefaultCategory();
    this.setDefaultAccount();
  },
  computed: {
    ...mapState('payment', ['paymentCollection']),
    ...mapState('category', ['categoryCollection']),
    ...mapState('account', ['accountCollection']),
    ...mapState('purchase', ['payments', 'taxCalc', 'purchase']),
    isValidPayment() {
      return (
        (this.payments.payment.paymentModeId &&
          this.valorUS(this.payments.payment.value) > 0 &&
          this.payments.remainder > 0 &&
          this.valorUS(this.payments.payment.value) <=
            this.payments.remainder &&
          this.payments.payment.paymentType?.tPag !== NENHUM) ||
        this.editPayment
      );
    },
    hasNoneInPaymentModeCollection() {
      return !!this.payments.paymentModeCollection.find((e) => e.type === 1);
    },
  },
  methods: {
    ...mapActions('payment', ['setPaymentCollection']),
    ...mapActions('account', ['setAccountCollection']),
    ...mapActions('category', ['setCategoryCollection']),
    ...mapActions('purchase', [
      'setRemainder',
      'setPayment',
      'setInstallmentsValues',
      'setInstallmentsDates',
    ]),
    async setInitialCollections() {
      await Promise.all([
        this.setPaymentCollection(),
        this.setAccountCollection(),
      ]);
    },
    setDefaultCategory() {
      this.payments.payment.category = this.categoryCollection.find(
        (e) => e.isDefault,
      );
    },
    isNoneByString(name) {
      const none = 'Nenhum';
      return name === none;
    },
    setDefaultAccount() {
      this.payments.payment.account = this.accountCollection.find(
        (e) => e.isDefault,
      );
    },
    setRemainderToValue() {
      this.payments.payment.value = this.payments.remainder;
    },
    async changePaymentValue() {
      const calculatedRange = this.calculateInstallments(
        this.payments.payment,
        this.valorUS(this.payments.payment.value),
      );

      await this.setInstallmentsValues(calculatedRange);
      await this.setInstallmentsDates(calculatedRange);
    },
    async changePaymentSelected(selectedPayment) {
      if (selectedPayment && selectedPayment.paymentType?.tPag !== NENHUM) {
        this.setDefaultAccount();
        const { remainder } = this.payments;
        const { account, category } = this.payments.payment;
        const payment = {
          ...selectedPayment,
          account: selectedPayment.account ?? account,
          category,
          id: undefined,
          value: remainder,
          paymentModeId: selectedPayment.id,
        };
        const calculatedRange = this.calculateInstallments(
          payment,
          payment.value,
        );

        await this.setPayment(payment);
        await this.setInstallmentsValues(calculatedRange);
        await this.setInstallmentsDates(calculatedRange);
        return;
      }
      this.payments.range = [];
      this.editPayment = false;
      this.payments.payment = [];
      this.setDefaultCategory();
      this.setDefaultAccount();
    },
    changeAccountSelected(selectedAccount) {
      if (!selectedAccount) return;
      this.payments.payment.account = selectedAccount;
    },
    changeCategorySelected(selectedCategory) {
      if (!selectedCategory) return;
      this.payments.payment.category = selectedCategory;
    },
    setDefaultFields() {
      const { paymentModeCollection } = this.payments;
      if (!paymentModeCollection.length) {
        this.setPaymentModeToNone();
      }
    },
    setPaymentModeToNone() {
      const paymentNone = this.paymentCollection.find((e) => e.type === 1);
      const serializedPaymentNone = {
        ...paymentNone,
        id: undefined,
        value: 0,
        paymentModeId: paymentNone.id,
      };
      this.payments.paymentModeCollection.push(serializedPaymentNone);
      this.payments.payment = {};
      this.payments.payment.account = {};
      this.payments.payment.category = {};
      this.payments.range = [];
      this.payments.edited = true;
    },
    async setPaymentModeCollection() {
      this.payments.payment.value = this.calcTotalRange(this.payments.range);
      if (Array.isArray(this.payments.range) && this.payments.range.length) {
        this.payments.payment.range = this.payments.range.map((e) => ({
          value: this.valorUS(e.value),
          date: this.$moment(e.date).format('YYYY-MM-DD'),
        }));
      }
      this.payments.paymentModeCollection.push(this.payments.payment);
      this.payments.payment = [];
      this.payments.range = [];
      this.payments.edited = true;
      await this.setRemainder();
      await this.setRemainderToValue();
    },
    cancelEditPaymentModeCollection() {
      this.payments.payment = {};
      this.payments.range = [];
      this.editPayment = false;
      this.indexEdit = null;
    },
    async removePaymentModeCollection(index) {
      this.payments.paymentModeCollection.splice(index, 1);
      this.payments.edited = true;
      await this.setRemainder();
      await this.setRemainderToValue();
    },
    async editPaymentModeCollection(index) {
      const paymentModeCollection = _.cloneDeep(
        this.payments.paymentModeCollection,
      );
      this.indexEdit = index;
      this.editPayment = true;
      await this.setPayment(paymentModeCollection[index]);
      await this.setInstallmentsValues(paymentModeCollection[index].range);
      await this.setInstallmentsDates(paymentModeCollection[index].range);
    },
    async saveEditPaymentModeCollection() {
      this.editPayment = false;
      await this.removePaymentModeCollection(this.indexEdit);
      await this.setPaymentModeCollection();
      this.indexEdit = null;
    },
    calcTotalRange(range) {
      return range.reduce((acc, obj) => acc + this.valorUS(obj.value), 0);
    },
  },
};
</script>
<style>
.table-installments {
  max-height: 400px !important;
  overflow: auto !important;
}
</style>
